function About() {

  return (
    <div className="about-container">
      <img className="about" src="https://creativesupply.com/wp-content/uploads/2018/07/05_BrewDog-810x540.png" alt="about"/>
    </div>
  )

}

export default About